import React, { Component } from 'react';

class SeatNum extends Component {
    render() {
        console.log("SeatNum:"+this.props.Sitnum);        
        return (
            <b className="seat-no">{this.props.Sitnum}</b>
        );
    }
}

export default SeatNum;